<template>
  <PrintCarousel  v-if="underMedLarge" :title="title" :images="images" v-on:contact="contact($event)"/>
    <PrintInteractive v-else :title="title" :images="images" v-on:contact="contact($event)"/>
</template>

<script>
import ScreenSize from "@/mixins/screen-size";
import { title, images } from "@/lib/print/showcase/renovations";
import PrintCarousel from "@/components/print/below/showcase/Carousel.vue";
import PrintInteractive from "@/components/print/below/showcase/Interactive.vue";

export default {
  mixins: [ScreenSize],
  data() {
    return { title, images };
  },
  components: { PrintCarousel, PrintInteractive },
  methods: {
    contact(spec) {
      this.$emit("contact", spec);
    }
  },
  metaInfo: {
    title: "Hotel Renovation Announcement | Brand Relaunch Campaign",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Announce your hotel renovation or brand relaunch plans in style. Our graphic design team creates full sized posters, fact sheets, and table-top signage for any event imaginable."
      }
    ],
    link: [
      {
        vmid: "canonical",
        rel: "canonical",
        href: "https://allthingshospitality.com/print/renovations"
      }
    ]
  }
};
</script>
